if ($("#dashboard").length) {

    let URL = APP_URL;

    $('#update_password').on('submit', function(event) {
        event.preventDefault();
        window
            .axios
            .post(URL + '/alter-password', {
                old_pass: document.getElementById('old_pass').value,
                password: document.getElementById('password').value,
                confirm_pass: document.getElementById('confirm_pass').value
            })
            .then(function(response) {
                //handle success
                console.log(response.data);
                $(".alert").remove();
                $(".resp").removeClass("d-none");
                if (response.data.status == false) {
                    $(".resp").append($('<div class="alert alert-danger" role="alert">' +
                        response.data.message + '</div>'));
                } else {
                    $(".resp").append($('<div class="alert alert-success" role="alert">' +
                        response.data.message + '</div>'));
                    $('#update_password input').val("");
                }

            })
            .catch(function(response) {
                //handle error
                console.log(response);
            });

    })


    $('#user-data').on('submit', function(event) {
        event.preventDefault()
        console.log('url ' + URL)

        var bodyFormData = new FormData(document.querySelector("#user-data"));
        bodyFormData.set('imagem', document.getElementById('imagem').files[0]);
        bodyFormData.append('caminho', 'user');

        axios({
                method: 'post',
                url: URL + '/update-data-user',
                data: bodyFormData,
                headers: { 'Content-Type': 'multipart/form-data' }
            })
            .then(function(response) {
                //handle success
                console.log(response);
                $(".resp-user").removeClass('d-none');
                $(".error").remove();
                if (response.data.status == true) {

                    $(".resp-user").append($('<div class=" alert alert-success" role="alert">' +
                        response.data.message + '</div>'));
                    $('#update_password input').val("");
                    setTimeout(function() { location.reload(); }, 2000);


                } else {
                    $(".resp-user").append($('<div class=" error alert alert-danger" role="alert">' +
                        response.data.errors + '</div>'));

                }

            })
            .catch(function(response) {
                //handle error
                console.log(response);
            });
    });









}